import React from 'react'
import { Box, Typography, Tabs, Tab } from '@mui/material'

const platforms = [
  {
    label: 'Webflow',
    steps: [
      'Log in to Webflow → Open Designer',
      'Add → Embed Code → Paste',
      'Save → Publish'
    ]
  },
  {
    label: 'WordPress',
    steps: [
      'Go to WP Admin → Appearance → Theme Editor',
      'Open header.php → Paste script before </head>',
      'Click Update File'
    ]
  },
  {
    label: 'Wix',
    steps: [
      'Wix Admin → Settings → Custom Code',
      'Add Code → Paste',
      'Place in Head → Apply'
    ]
  },
  {
    label: 'Custom HTML',
    steps: [
      'Open HTML file (e.g., index.html)',
      'Paste before </head>',
      'Upload to server'
    ]
  },
  {
    label: 'Shopify',
    steps: [
      'Admin → Online Store → Themes → Actions → Edit Code',
      'Open theme.liquid → Paste before </head>',
      'Click Save'
    ]
  }
]

export const InstructionsTabs = () => {
  const [tabIndex, setTabIndex] = React.useState(0)

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(e, newValue) => setTabIndex(newValue)}
        variant='scrollable'
        scrollButtons='auto'
        sx={{ mb: 2 }}
      >
        {platforms.map((platform, idx) => (
          <Tab key={platform.label} label={platform.label} />
        ))}
      </Tabs>

      <Box sx={{ px: 1 }}>
        {platforms[tabIndex].steps.map((step, idx) => (
          <Typography
            key={idx}
            variant='body2'
            sx={{
              mb: 1,
              pl: 1,
              borderLeft: '3px solid #ddd',
              ml: 1,
              color: 'text.secondary'
            }}
          >
            • {step}
          </Typography>
        ))}
      </Box>
    </>
  )
}
